import { render } from "./CreateHotListModal.vue?vue&type=template&id=19e20262&scoped=true"
import script from "./CreateHotListModal.vue?vue&type=script&lang=js"
export * from "./CreateHotListModal.vue?vue&type=script&lang=js"

import "./CreateHotListModal.vue?vue&type=style&index=0&id=19e20262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e20262"]])

export default __exports__